// src/services/authService.js
import api from './api';

export const authService = {
  // 슬러그 가용성 체크 (실시간 검증)
  async checkSlug(slug) {
    const response = await api.get('/auth/check-slug', { params: { slug } });
    return response.data; // { slug, available, reason? }
  },

  // 신규 고객사(테넌트) 셀프 가입
  async businessSignup(payload) {
    const response = await api.post('/auth/business-signup', payload);
    const { access_token, refresh_token } = response.data;
    localStorage.setItem('accessToken', access_token);
    localStorage.setItem('refreshToken', refresh_token);
    return response.data;
  },

  async login(email, password) {
    const response = await api.post('/auth/login', { email, password });
    const { access_token, refresh_token } = response.data;
    localStorage.setItem('accessToken', access_token);
    localStorage.setItem('refreshToken', refresh_token);
    return response.data;
  },

  logout() {
    // 서버 세션 폐기 (best-effort) — 탈취된 refresh token 재사용 차단
    const refreshToken = localStorage.getItem('refreshToken');
    if (refreshToken) api.post('/auth/logout', { refresh_token: refreshToken }).catch(() => {});
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
  },

  async getMe() {
    const response = await api.get('/auth/me');
    return response.data;
  },

  async refreshToken() {
    const refreshToken = localStorage.getItem('refreshToken');
    const response = await api.post('/auth/refresh', {
      refresh_token: refreshToken,
    });
    const { access_token, refresh_token: newRefresh } = response.data;
    localStorage.setItem('accessToken', access_token);
    localStorage.setItem('refreshToken', newRefresh);
    return response.data;
  },

  isAuthenticated() {
    return !!localStorage.getItem('accessToken');
  },
};
